import { BetInterfaceButton } from '../betInterface.button.class'

/**
 * @file Defines the {@link BetInterfaceSettingsButton} class.
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /** 
  * Class for handling bet interface buttons
  * @extends BetInterfaceButton
  */
  export class BetInterfaceSettingsButton extends BetInterfaceButton {

    /**
     * Initialise content of bet interface button
     * @param {interface-button} b_ - Object containing ID and content of button
     */
    constructor(b_) {
        super(b_) //Call parent constructor
    }

    /** Get coins */ get coins()   { return this._coins }
    /** Set coins */ set coins(v_) { this._coins = v_ }

    /**
     * Click handler for bet interface settings buttons
     */
    click() {

        balanceManager_.toggleCredits()                         //Toggle to cash
        let e = document.getElementById('betPage')              //Retrieve iron dog bet settings node
        let c = e.querySelectorAll('input[type="checkbox"]')[0] //Store checkbox node
        c.checked = balanceManager_.getShowIncredits()          //Set checkbox

    }

  }